module.exports = __webpack_public_path__ + "img/gp.4a13339f.svg";